import { MultiSelect, Select, Text, rem } from '@mantine/core';
import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { BiSolidDownArrow } from 'react-icons/bi';
import { useState } from 'react';
import { useEmployeeFormContext } from '../NewEmployeePage';

interface Roles {
  value: string;
  label: string;
}

interface Services {
  id: number;
  code: string;
  name: string;
}

export const RoleSelectCard: React.FC = () => {
  const form = useEmployeeFormContext();
  const [selectedService, setSelectedService] = useState<string>(''); // select values
  const [selectedServices, setSelectedServices] = useState<string[]>([]); // multiselect values
  const icon = (
    <BiSolidDownArrow
      style={{ width: rem(10), height: rem(10), color: 'gray' }}
    />
  );
  const { data: roles } = useSWR<Roles[]>('mappings/roles', getFetcher);
  const { data: services } = useSWR<Services[]>('services', getFetcher);

  let roleOptions: any = [];
  roleOptions = roles
    ? Object.entries(roles)
        .filter(([value, label]) => value !== 'CLIENT')
        .map(([value, label]) => ({
          value,
          label,
        }))
        // eslint-disable-next-line @typescript-eslint/no-base-to-string
        .sort((a, b) => a.label.toString().localeCompare(b.label.toString()))
    : [];

  const serviceOptions: string[] = [];
  services?.forEach(service => {
    serviceOptions.push(service.name);
  });

  const handleChangeRole = (value: string | null) => {
    form.setFieldValue('access.role', value);
    const values = value === 'ADMIN' ? serviceOptions : [];
    if (value !== 'ADMIN' && value !== 'COORDINATOR') handleChangeService('');

    handleChangeServices(values);
  };

  const handleChangeService = (value: string) => {
    setSelectedService(value);
    form.setFieldValue('access.services', []);

    services?.forEach(service => {
      if (value === service.name)
        form.insertListItem('access.services', service.id);
    });
  };

  const handleChangeServices = (values: string[]) => {
    setSelectedServices(values);
    form.setFieldValue('access.services', []);

    services?.forEach(service => {
      if (values.includes(service.name))
        form.insertListItem('access.services', service.id);
    });
  };

  function showSelectServices(): JSX.Element {
    const role = form.values.access.role;
    switch (role) {
      case '':
      case 'ADMIN':
      case 'COORDINATOR':
        return (
          <div>
            <MultiSelect
              variant="default"
              radius="md"
              rightSection={icon}
              placeholder={role === 'ADMIN' ? '' : 'vyberte služby'}
              disabled={role !== 'COORDINATOR'}
              value={selectedServices}
              data={serviceOptions}
              onChange={values => {
                if (role !== 'ADMIN') handleChangeServices(values);
              }}
            />
          </div>
        );

      case 'CAREGIVER':
      case 'SERVICE_MANAGER':
      case 'SOCIAL_WORKER':
        return (
          <div>
            <Select
              variant="default"
              radius="md"
              rightSection={icon}
              placeholder={'vyberte služby'}
              value={selectedService}
              data={serviceOptions}
              onChange={value => {
                value ? handleChangeService(value) : handleChangeService('');
              }}
            />
          </div>
        );
      default:
        return <div>UNDEFINED ROLE</div>;
    }
  }

  return (
    <div>
      <label style={{ display: 'flex', alignItems: 'center' }}>
        <Text fw={700} size="lg" style={{ marginRight: '5px' }}>
          Role
        </Text>
        <span style={{ color: 'red' }}>*</span>
      </label>
      <Select
        style={{
          width: '30%',
        }}
        radius="md"
        variant="filled"
        placeholder="vyberte roli"
        allowDeselect={false}
        value={form.values.access.role}
        data={roleOptions}
        onChange={value => handleChangeRole(value)}
      />
      <label style={{ display: 'flex', alignItems: 'center' }}>
        <Text fw={700} size="lg" style={{ marginRight: '5px' }}>
          Služby
        </Text>
        <span style={{ color: 'red' }}>*</span>
      </label>
      {showSelectServices()}
    </div>
  );
};
